<!--suppress XmlInvalidId -->
<template>
  <ws-modal-dialog :on-close="handleClose" focused="email">
    <div class="modal-header">
      <span class="modal-title" id="exampleModalLabel">Lost Your password?</span>
      <button @click="closeModal" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="text-center">
        <div class="alert alert-warning modal-alert">
          <p class="alert-heading">Enter email address you registered with.</p>

          We will send you an email with a link to the email address you entered below. Once you have received the email
          click on the link in the email to reset your password.
        </div>
        <form role="form">
          <div class="form-group">
            <label for="email">Your Email Address</label>
            <ws-text-input v-model="email" name="email" field="email" id="email"/>
          </div>
          <!-- The id for popup dailog buttons must be unique to the application -->
          <ws-signal-button id="login-password-request-submit-btn" class="btn btn-primary modal-submit" text="Submit"
                            data-dismiss="modal"
                            :disabled="!canSubmit()" :aria-disabled="!canSubmit()"
                            :onSubmit="handleSubmit"/>
        </form>
        <p class="m-t text-muted">
          <small>&copy; {{ copyright }}</small>
        </p>
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-danger btn-sm modal-close" @click="closeModal" data-dismiss="modal">Close
      </button>
    </div>
  </ws-modal-dialog>
</template>

<script>
import WsModalDialog from '@/views/dialog/ModalDialog'
import ApiService from '@/common/api.service'

export default {
  name: 'LoginSupportRequest',
  data () {
    return {
      email: ''
    }
  },
  methods: {
    canSubmit () {
      return this.email !== ''
    },

    closeModal () {
      this.$parent.$emit('closeLoginPasswordRequest')
    },

    handleSubmit () {
      let reset_url
      if (process.env.WEB_URL.endsWith('/#/')) {
        reset_url = process.env.WEB_URL + 'users/password/reset'
      } else {
        // Add the bang in case it isn't setup correctly in the configuration
        reset_url = process.env.WEB_URL + '/#/users/password/reset'
      }

      // Save data
      ApiService
        .post('auth/pwd-reset-request', {
          email: this.email,
          reset_url: reset_url
        })
        .then((response) => {
          this.closeModal()
          return response
        })
    },

    handleClose () {
      this.closeModal()
    }
  },
  computed: {
    copyright () {
      return process.env.COPYRIGHT
    }
  },
  components: {
    WsModalDialog
  }
}
</script>

<style scoped>
  .alert-heading {
    margin-bottom: 0.5rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/support/LoginPasswordRequest.vue